import React, { Component } from 'react';
import { Route } from 'react-router';
import { FullscreenLayout } from './FullscreenLayout';

type FullscreenLayoutRouteProps = {
    component: any;
    path?: string;
    exact?: boolean;
}

export const FullscreenLayoutRoute = (props: FullscreenLayoutRouteProps) => {

    const { component: Component, ...rest } = props;

    return (<Route
        {...rest}
        render={props => (
            <FullscreenLayout>
                <Component {...props} />
            </FullscreenLayout>
        )} />
    )
};

